export default __webpack_public_path__ + "static/media/fontello.ee64e5c9.ttf";